import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  id: "navbar_mobile",
  class: "row mx_0_5"
}
const _hoisted_3 = { class: "col_auto py_0_5 items_center" }
const _hoisted_4 = { class: "col_auto py_0_5 mx_auto items_center" }
const _hoisted_5 = { class: "col_auto py_0_5 items_center" }
const _hoisted_6 = {
  id: "navbar",
  class: "row mx_0_5"
}
const _hoisted_7 = { class: "col pb_0_5 pt_md_0_5" }
const _hoisted_8 = { class: "ml_auto px_1 py_0_5 items_center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav_link"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                class: "club_logo",
                src: "/images/navbar_logo.png"
              }, null, -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "nav_link"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("span", { class: "club_name" }, "TAEGUK Essen e.V.", -1)
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            id: "navbar_toggler",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNavbar && _ctx.toggleNavbar(...args)))
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "16",
              height: "16",
              fill: "currentColor",
              class: "bi bi-list",
              viewBox: "0 0 16 16"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
              })
            ], -1)
          ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: "/",
                "active-class": "active",
                class: "nav_link"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode("Startseite")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'training' },
                "active-class": "active",
                class: "nav_link"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("Training")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'kontakt' },
                "active-class": "active",
                class: "nav_link"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("Kontakt & Anfahrt")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'training-home' },
                "active-class": "active",
                class: "nav_link"
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("Training zu Hause")
                ])),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createElementVNode("button", {
                id: "toggle_btn",
                class: "toggle_btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleThemeSwitch && _ctx.toggleThemeSwitch(...args)))
              }),
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                for: "toggle_btn",
                class: "ml_0_5 items_center"
              }, [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "18",
                  height: "18",
                  fill: "currentColor",
                  class: "bi bi-moon-fill",
                  viewBox: "0 0 16 16"
                }, [
                  _createElementVNode("path", { d: "M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278" })
                ])
              ], -1))
            ])
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1))
        ])
      ])
    ])
  ]))
}